export function getAwsApiBaseUrl() {
  return process.env.REACT_APP_AWSServerURL;
}
